export default "__VITE_ASSET__CfmVJUpS__"